{
  "create": "Create Template",
  "createTemplate": "Create Asset Template",
  "templateName": "Template Name",
  "modelFamily": "Model Family",
  "description": "Description",
  "dateModified": "Date Modified",
  "status": "Status",
  "filters": {
    "state": "Status"
  },
  "states": {
    "active": "Active",
    "draft": "Draft",
    "archived": "Archived",
    "any": "Any"
  },
  "actions": {
    "edit": "Edit Template",
    "activate": "Activate Template",
    "moveToDraft": "Move to Draft",
    "moveToArchive": "Move to Archive"
  },
  "detailsModal": {
    "title": "Template Details",
    "assetClasses": "Asset Classes",
    "close": "Close"
  },
  "error": {
    "transition": "Failed to update template status",
    "update": "Failed to update template"
  },
  "success": {
    "transition": "Template status updated successfully",
    "update": "Template updated successfully"
  }
}
